import { useState } from "react";
import { ListBrand } from "../components/brand/ListBrand";
import { CreateBrand } from "../components/brand/CreateBrand";
import { UpdateBrand } from "../components/brand/UpdateBrand";

export const Brand = () => {
  const [mode, setMode] = useState<"list" | "edit" | "create">("list");
  const [selectedId, setSelectedId] = useState<string | null>(null);
  if (mode === "create") {
    return <CreateBrand onBack={() => setMode("list")} />;
  }
  if (mode === "edit" && selectedId) {
    return (
      <UpdateBrand
        id={selectedId}
        onBack={() => {
          setSelectedId(null);
          setMode("list");
        }}
      />
    );
  }
  return (
    <ListBrand
      onCreate={() => setMode("create")}
      onUpdate={(id: string) => {
        setSelectedId(id);
        setMode("edit");
      }}
    />
  );
};
